/* eslint-disable no-undef */
import NProgress from 'nprogress';
import { useAuthStore } from '@/stores/auth';
import axios from 'axios';
import axios2 from 'axios';
import { createPinia } from 'pinia';
import VueAxios from 'vue-axios';

console.log(process.env);

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL,
  apiVersion = process.env.VUE_APP_API_VERSION,
  apiUrl = process.env.VUE_APP_API_URL + apiVersion,

  pinia = createPinia(),
  store = useAuthStore(pinia),

  COMMON_HEADERS = {
    common: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
  Auth = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: true,
    withXSRFToken: true,
    headers: COMMON_HEADERS,
  }),
  Api = axios2.create({
    baseURL: apiUrl,
    withCredentials: true,
    withXSRFToken: true,
    headers: COMMON_HEADERS,
  });

// Add a flag to track if we're already handling an auth check
let isCheckingAuth = false;

Api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response &&
      [401, 419].includes(error.response.status) &&
      store.authUser &&
      !store.guest &&
      !isCheckingAuth
    ) {
      isCheckingAuth = true;
      try {
        await store.logout();
      } finally {
        isCheckingAuth = false;
      }
    }
    return Promise.reject(error);
  }
);

Auth.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response &&
      [401, 419].includes(error.response.status) &&
      store.authUser &&
      !store.guest &&
      !isCheckingAuth
    ) {
      isCheckingAuth = true;
      try {
        await store.logout();
      } finally {
        isCheckingAuth = false;
      }
    }
    return Promise.reject(error);
  }
);

let activeRequests = 0;

const setupInterceptors = (axiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    if (activeRequests === 0) {
      NProgress.start();
    }
    activeRequests++;
    return config;
  });

  const handleResponse = () => {
    activeRequests--;
    if (activeRequests === 0) {
      NProgress.done();
    }
  };

  axiosInstance.interceptors.response.use(
    (response) => {
      handleResponse();
      return response;
    },
    (error) => {
      handleResponse();
      return Promise.reject(error);
    }
  );
};

setupInterceptors(Api);
setupInterceptors(Auth);

export default {
  vueAxios: VueAxios,
  auth: Auth,
  api: Api,
};
